import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className="pagination">
      {/* First Page Button */}
      <button
        onClick={() => onPageChange(0)}
        disabled={currentPage === 0}
        className="pagination-button"
      >
        İlk
      </button>

      {/* Previous Page Button */}
      <button
        onClick={() => onPageChange(Math.max(0, currentPage - 1))}
        disabled={currentPage === 0}
        className="pagination-button"
      >
        Önceki
      </button>

      {/* Page Numbers */}
      {(() => {
        const pages = [];
        const startPage = Math.max(0, Math.min(currentPage - 2, totalPages - 5));
        const endPage = Math.min(startPage + 4, totalPages - 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => onPageChange(i)}
              className={`pagination-button ${currentPage === i ? 'active' : ''}`}
            >
              {i + 1}
            </button>
          );
        }
        return pages;
      })()}

      {/* Next Page Button */}
      <button
        onClick={() => onPageChange(Math.min(totalPages - 1, currentPage + 1))}
        disabled={currentPage === totalPages - 1 || totalPages === 0}
        className="pagination-button"
      >
        Sonraki
      </button>

      {/* Last Page Button */}
      <button
        onClick={() => onPageChange(totalPages - 1)}
        disabled={currentPage === totalPages - 1 || totalPages === 0}
        className="pagination-button"
      >
        Son ({Math.max(1, totalPages)})
      </button>

      {/* Go to Page Input */}
      <div className="go-to-page">
        <input
          type="number"
          min="1"
          max={totalPages}
          placeholder="Sayfa"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              const page = parseInt(e.target.value);
              if (page >= 1 && page <= totalPages) {
                onPageChange(page - 1);
                e.target.value = ''; // Clear the input after navigation
              }
            }
          }}
          className="page-input"
        />
        <button
          onClick={() => {
            const input = document.querySelector('.page-input');
            const page = parseInt(input.value);
            if (page >= 1 && page <= totalPages) {
              onPageChange(page - 1);
              input.value = ''; // Clear the input after navigation
            }
          }}
          className="pagination-button"
        >
          Git
        </button>
      </div>

      {/* <style jsx>{`
        .pagination {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          margin-top: 20px;
        }

        .pagination-button {
          padding: 8px 12px;
          border: 1px solid #ddd;
          background-color: white;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .pagination-button:hover:not(:disabled) {
          background-color: #f0f0f0;
        }

        .pagination-button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .pagination-button.active {
          background-color: #007bff;
          color: white;
          border-color: #007bff;
        }

        .go-to-page {
          display: flex;
          align-items: center;
          gap: 4px;
          margin-left: 8px;
        }

        .page-input {
          width: 50px;
          padding: 8px;
          border: 1px solid #ddd;
          border-radius: 4px;
          text-align: center;
        }

        .page-input::-webkit-inner-spin-button,
        .page-input::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        .page-input:focus {
          outline: none;
          border-color: #007bff;
        }
      `}</style> */}
    </div>
  );
};

export default Pagination; 